import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';

const wrapper = css`
  box-sizing: border-box;
  border-radius: 15px;
  box-shadow: 2px 2px 29px 0 #f1f2f2;
  border: solid 0.5px #dbdbdb;
  background-color: #ffffff;
  padding: 18px;
  width: 100%;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #414042;
  resize: none;
  height: 16em;
  :focus {
    outline: none;
  }
  @media (min-width: ${BREAKPOINT_SMALL}) {
    padding: 23px;
    font-size: 16px;
    color: #9e9e9e;
    height: 6em;
  }
`;

interface ITextAreaProps {
  value?: string;
  placeholder?: string;
  maxLength?: number;
  maxNumberOfLines?: number;
  onChange?(e: React.ChangeEvent<HTMLTextAreaElement>): void;
  [key: string]: any;
}

export const TextArea = observer(
  ({ value, placeholder, onChange, maxLength, maxNumberOfLines, ...props }: ITextAreaProps) => {
    function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
      const val = e.target.value;
      const numberOfLines = (val.match(/\n/g) || []).length + 1;

      if (!onChange) {
        return;
      }

      const validations = [
        maxLength ? val.length <= maxLength : true,
        maxNumberOfLines ? numberOfLines <= maxNumberOfLines : true,
      ];

      if (validations.every(Boolean)) {
        onChange(e);
      }
    }

    return (
      <textarea
        className={`${wrapper} ${props.customClass || ''}`}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        {...props}
      />
    );
  },
);
